import BatchImageUploader from "@/components/hashedBulkUpload";
import React, { useState} from 'react';

function UploadOriginal() {
  const [uploadConfig] = useState({
    imageKind: "original",
    directory: "imported"
  });

  return (
    <BatchImageUploader 
      imageKind={uploadConfig.imageKind}
      directory={uploadConfig.directory}
    />
  );
}

export default UploadOriginal;